module.exports = "/static/media/logo-phone-by-webcom-loader.bfa6adf2.svg";